
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Admin from '../pages/admin/page';
import Student from '../pages/student/page';
import Teacher from '../pages/teacher/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/student',
    element: <Student />,
  },
  {
    path: '/teacher',
    element: <Teacher />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
